    export function jumpToAccordion(){

        var LABEL_OVERRIDES = {
            'rank-math-faq': 'FAQ',
            'faqs': 'FAQs',
            'farlo-cal' : 'Calendar',
        };

        var REGEX_RENAMES = [
            { test: /^rank[-_]?math[-_]?faq(s)?$/i, replaceWith: 'FAQ' },
            { test: /^faq(s)?[-_]?block$/i,        replaceWith: 'FAQs' }
        ];

        var IGNORE_IDS = new Set(['calendar', 'wpadminbar', 'page']);

        var SELECTORS = [
            'main section[id]',
            'main div[id]',
            'main article[id]',
            '.entry-content section[id]',
            '.entry-content div[id]',
            '.entry-content article[id]',
            '.entry-content h2[id]',
            '.entry-content h3[id]'
        ].join(',');

        function toTitleCaseLabelFromId(id){
            if (!id) return '';
            var cleaned = id.replace(/[_\-]+/g, ' ').replace(/^\W+/, '').trim();
            if (!cleaned) return id;
            return cleaned.split(' ').map(function(w){
                return w ? (w.charAt(0).toUpperCase() + w.slice(1)) : w;
            }).join(' ');
        }

        function renameLabel(id, fallbackLabel){
            if (LABEL_OVERRIDES[id]) return LABEL_OVERRIDES[id];

            for (var i=0; i<REGEX_RENAMES.length; i++) {
                if (REGEX_RENAMES[i].test.test(id)) return REGEX_RENAMES[i].replaceWith;
            }

            var label = fallbackLabel || toTitleCaseLabelFromId(id);


            if (/^faq$/i.test(label)) label = 'FAQ';

            return label;
        }

        function isVisible(el) {
            if (!el) return false;
            var rect = el.getBoundingClientRect();
            var style = window.getComputedStyle(el);
            return style && style.display !== 'none' && style.visibility !== 'hidden' && rect.width >= 1 && rect.height >= 1;
        }

        function buildList() {
            var nodes = Array.prototype.slice.call(document.querySelectorAll(SELECTORS));
            var seen = new Set();
            var items = [];
            nodes.forEach(function(el){
                var id = el.id || '';
                if (!id || seen.has(id) || IGNORE_IDS.has(id)) return;
                if (!isVisible(el)) return;

                var label = renameLabel(id, toTitleCaseLabelFromId(id));

                if (/^faq\s*question/i.test(label)) return;
                if (/^farlo-ui-crm/i.test(id)) return;
                seen.add(id);
                items.push({ id:id, label:label, el:el });
            });
            return items;
        }

        function createLinkItem(item) {
            var li = document.createElement('li');
            var a = document.createElement('a');
            a.href = '#' + item.id;
            a.textContent = item.label || item.id;
            a.addEventListener('click', function(e){
                var target = document.getElementById(item.id);
                if (target) {
                    e.preventDefault();
                    target.setAttribute('tabindex','-1');
                    target.focus({ preventScroll: true });
                    window.history.pushState({}, '', '#' + item.id);
                    target.scrollIntoView({ behavior: 'smooth', block: 'start' });
                    closeAccordionSmooth();
                }
            });
            li.appendChild(a);
            return li;
        }

        var acc, panel, panelInner;
        function openAccordionSmooth(){
            if (!acc || !panel) return;
            if (acc.open) return;
            acc.setAttribute('open', '');
            panel.classList.add('is-animating');
            panel.style.maxHeight = '0px';
            if (!panelInner) {
                panelInner = document.createElement('div');
                panelInner.className = 'farlo-jump-panel--content';
                while(panel.firstChild) panelInner.appendChild(panel.firstChild);
                panel.appendChild(panelInner);
            }
            var target = panel.scrollHeight;
            requestAnimationFrame(function(){
                panel.style.maxHeight = target + 'px';
            });
            panel.addEventListener('transitionend', function onEnd(){
                panel.classList.remove('is-animating');
                panel.style.maxHeight = '45vh';
                panel.removeEventListener('transitionend', onEnd);
            });
        }
        function closeAccordionSmooth(){
            if (!acc || !panel) return;
            if (!acc.open) return; 
            panel.classList.add('is-animating');
            var start = panel.scrollHeight;
            panel.style.maxHeight = start + 'px';
            requestAnimationFrame(function(){
                panel.style.maxHeight = '0px';
            });
            panel.addEventListener('transitionend', function onEnd(){
                acc.removeAttribute('open');
                panel.classList.remove('is-animating');
                panel.style.maxHeight = '0px';
                panel.removeEventListener('transitionend', onEnd);
            });
        }

        function init() {
            var bar = document.getElementById('farlo-jump-bar');
            var listEl = document.getElementById('farlo-jump-list');
            var calBtn = document.getElementById('farlo-jump-calendar');
            acc   = document.getElementById('farlo-jump-accordion');
            panel = document.getElementById('farlo-jump-panel');

            if (!bar || !listEl || !calBtn || !acc || !panel) return;

            var items = buildList();
            items.forEach(function(item){ listEl.appendChild(createLinkItem(item)); });

            var hasCalendar = !!document.getElementById('calendar');
            if (hasCalendar) {
                calBtn.hidden = false;
                calBtn.addEventListener('click', function(e){
                    var target = document.getElementById('calendar');
                    if (target) {
                        e.preventDefault();
                        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
                        window.history.pushState({}, '', '#calendar');
                    }
                });
            }

            if (items.length > 0 || hasCalendar) bar.hidden = false;

            var summary = acc.querySelector('.farlo-jump-summary');
            summary.addEventListener('click', function(e){
                e.preventDefault();
                if (acc.open) closeAccordionSmooth(); else openAccordionSmooth();
            });

            summary.addEventListener('keydown', function(e){
                if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault();
                    if (acc.open) closeAccordionSmooth(); else openAccordionSmooth();
                }
            });

            var deb;
            ['load','resize'].forEach(function(evt){
                window.addEventListener(evt, function(){
                    clearTimeout(deb);
                    deb = setTimeout(function(){
                        if (listEl.children.length === 0) {
                            var again = buildList();
                            again.forEach(function(item){ listEl.appendChild(createLinkItem(item)); });
                            if (again.length > 0) bar.hidden = false;
                        }
                    }, 300);
                });
            });
        }

        if (document.readyState === 'complete' || document.readyState === 'interactive') {
            init();
        } else {
            document.addEventListener('DOMContentLoaded', init);
        }
    }